import { createSelector } from '@reduxjs/toolkit';
import { selectPromoSearchTypes } from 'shared/selectors/promoSearchTypes';

export const selectMortgageFastFilterOptions = createSelector([selectPromoSearchTypes], promoSearchTypes => {
  return [
    ...(promoSearchTypes?.mortgage?.map(({ value, name: label }) => ({
      value,
      label,
    })) || []),
  ];
});
